<template>
  <div class="step-consultations">
    <validation-provider rules="required" v-slot="{ errors }">
      <div class="form-group" :class="{ '-has-error': errors.length > 0 }">
        <label class="label" for="consultations">Consultas:</label>
        <multiselect
          :options="consultations"
          :multiple="false"
          class="form-control"
          label="label"
          track-by="name"
          id="consultations"
          placeholder="Selecione uma opção"
          select-label="Pressione enter para selecionar"
          selected-label="Selecionado"
          deselect-label="Pressione enter para remover"
          v-model="form.consultation"
        ></multiselect>
      </div>
    </validation-provider>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapState } from 'vuex';
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'StepConsultations',

  props: {
    form: {
      type: Object,
      required: true,
    },
  },

  model: {
    prop: 'form',
    event: 'input',
  },

  methods: {
  },

  computed: {
    ...mapState('compliance', {
      consultations: 'availableConsultations',
    }),
  },

  components: {
    ValidationProvider,
    Multiselect,
  },
};
</script>

<style scoped>

</style>
